import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GetSingleApproach } from "../../apis/user/get_single_approach";
import { API_STATUS } from "../../constants";
import HeaderMenu from "../sidebar/headermenu";
import ApproachMessage from "./approach_message";
import { GetUnreadMcount } from "../../apis/user/get_unread_mcount";
import { bool } from "yup";

export default function ApproachDetails() {
    const navigate = useNavigate();
    const [loginId, setLoginId] = useState('');
    const [AppData, setAppData] = useState('');
    const [getAppApi, setGetAppApi] = useState(API_STATUS);
    const [activeTab, setTab] = useState('details');
    const [mcount, setMcount] = useState(0);
    const [countApi, setCountApi] = useState(API_STATUS);

    const params = useParams({ aid: String,msg:bool });

    const getAppData = () => {
        GetSingleApproach(params.aid, setGetAppApi);
    }

    useEffect(() => {
        if (sessionStorage.getItem("LIVENESS") === '0') {
            navigate("/video_kyc_pending");
        }
    }, [navigate]);

    useEffect(() => {
        if(params.msg){
            setTab('message');
        }
        GetUnreadMcount(params.aid, setCountApi);
    }, []);

    useEffect(() => {
        if (!countApi.isLoader && !countApi.isError && countApi.data != null) {

            if (countApi.data.status === 1) {

                setMcount(countApi.data.data.mcount);
            }
        }
    }, [countApi]);

    useEffect(() => {
        if (!getAppApi.isLoader && !getAppApi.isError && getAppApi.data != null) {
            if (getAppApi.data.status === 1) {
                console.log(getAppApi.data.data);
                setAppData(getAppApi.data.data);
            }
        }
    }, [getAppApi]);

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);
            getAppData();
        }
    }, []);

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="max-w-2xl mx-auto">



                <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2 mt-20">


                    <hr className="border-t border-gray-100 dark:border-slate-700" />

                    <div className="relative -mb-px px-2" tabindex="-1" uk-slider="finite: true">

                        <nav className="overflow-hidden rounded-xl uk-slider-container pt-2">

                            <ul className="uk-slider-items w-[calc(100%+10px)] capitalize font-semibold text-gray-500 text-sm dark:text-white"
                                uk-switcher="connect: #setting_tab ; animation: uk-animation-slide-right-medium, uk-animation-slide-left-medium">

                                <li className="w-auto pr-2.5"> <Link
                                    onClick={() => {
                                        setTab('details');
                                    }}
                                    className="inline-block p-4 pt-2 border-b-2 border-transparent aria-expanded:text-blue-500 aria-expanded:border-blue-500"> Details </Link> </li>
                                <li className="w-auto pr-2.5"> <Link
                                    onClick={() => {
                                        setTab('message');
                                    }}
                                    className="inline-block p-4 pt-2 border-b-2 border-transparent aria-expanded:text-blue-500 aria-expanded:border-blue-500"> Message
                                    {
                                        mcount > 0 &&
                                        <span className="bg-blue-500 text-white text-xs ml-1" style={{ padding: '2px 7px', borderRadius: 15 }}>{mcount}</span>
                                    }
                                </Link> </li>
                            </ul>

                        </nav>



                    </div>

                </div>

                {
                    AppData !== "" && activeTab === 'details' &&
                    <div>
                        <div className="flex items-center gap-5 mt-5 bg-white p-2" style={{ paddingLeft: 22 }}>
                            <Link to={'/profile/' + AppData['clientId']} className="flex-5 p-2 bg-sky-100 hover:bg-opacity-80 transition-all rounded-lg cursor-pointer" aria-expanded="false">
                                <div className="relative w-12 h-12 shrink-0"> <img src={AppData.clientPic} alt="" className="object-cover w-full h-full rounded-full" /></div>

                            </Link>
                            <Link to={'/profile/' + AppData['clientId']} className="p-2 bg-white hover:bg-opacity-80 transition-all rounded-lg cursor-pointer" aria-expanded="false">
                                <p> <b className="font-bold mr-1"> {AppData.company}</b><br /> {AppData.category}</p>

                            </Link>
                            <div className="p-2 bg-sky-100 hover:bg-opacity-80 transition-all rounded-lg cursor-pointer" aria-expanded="false">
                                <i className="fa fa-exchange"></i>
                            </div>
                            <Link to={'/profile/' + AppData['userId']} className="p-2 bg-pink-100 hover:bg-opacity-80 transition-all rounded-lg cursor-pointer" aria-expanded="false">
                                <div className="relative w-12 h-12 shrink-0"> <img src={AppData.userPic} alt="" className="object-cover w-full h-full rounded-full" /></div>
                            </Link>
                            <Link to={'/profile/' + AppData['userId']} className="p-2 bg-white hover:bg-opacity-80 transition-all rounded-lg cursor-pointer" aria-expanded="false">
                                <p> <b className="font-bold mr-1"> {AppData.firstName + ' ' + AppData.lastName} </b><br /> {AppData.subCat}</p>
                                {/* <div className="text-xs text-gray-500 mt-1.5 dark:text-white/80"> 2 hours ago </div> */}
                            </Link>
                        </div>
                        <div className="p-2 bg-white mt-5">
                            <div class="text-sm text-gray-500 mt-1.5 dark:text-white/80"> Regards : {AppData.regard} </div>
                            <div class="text-sm text-gray-500 mt-1.5 dark:text-white/80"> Requirements : {AppData.requirement} </div>
                            <div class="text-sm text-gray-500 mt-1.5 dark:text-white/80"> Details : {AppData.detail} </div>
                        </div>
                    </div>
                }
                {
                   AppData !== "" && activeTab === 'message' &&
                    <ApproachMessage AppData={AppData} setMcount={setMcount} />
                }
            </div>
        </main>
    </div>
}